import { Navigate, Route, Routes } from "react-router-dom";
import routesList from "../Routes/routes";
import { checkUserAllowPermissions } from "../utils/common";

const Layout = ({ defaultRoute }) => {

    return (
        <>
            <Routes>
                <Route path="/" element={<Navigate to="/dashboard/xr" />} />

                {routesList.map((item) => {
                    const { path, element: ElementComponent, childElement, type, tabName, permissions } = item;
                    let hasPermission = item.permissions ? checkUserAllowPermissions(permissions) : true;
                    
                    return (
                        hasPermission && (
                            <Route
                                path={path}
                                key={path}
                                element={
                                    <ElementComponent
                                        type={type}
                                        tabName={tabName}
                                        {...(childElement && { ChildComponent: childElement })}
                                    />}
                            />
                        )
                    )
                })}

                <Route path="*" element={<Navigate to={defaultRoute} />} />
            </Routes>
        </>
    )
}

export default Layout;